import React from 'react';

const HeatDifferentialModeSelector = ({ currentMode, onModeChange, indicatorName, headerAction }) => {
  const modes = [
    { id: 'severity', label: 'Severity' },
    { id: 'avg_urban_temp_c', label: 'Avg Urban Temp C' },
    { id: 'avg_rural_temp_c', label: 'Avg Rural Temp C' }
  ];

  return (
    <div className="power-outage-mode-selector heat-differential-mode-selector" style={{ position: 'relative' }}>
      <h4 className="viz-mode-title">{indicatorName} - Visualization Mode</h4>
      <div className="power-mode-tabs-row">
        <div className="power-mode-tabs" style={{ gridTemplateColumns: `repeat(${modes.length}, 1fr)` }}>
        {modes.map((mode) => (
          <div
            key={mode.id}
            className={`power-mode-tab ${currentMode === mode.id ? 'active' : ''}`}
            onClick={() => onModeChange(mode.id)}
            style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            {mode.label}
          </div>
        ))}
        </div>
        {headerAction}
      </div>
    </div>
  );
};

export default HeatDifferentialModeSelector;
